export default __webpack_public_path__ + "static/media/red-roof.f9269d6c.png";